import { useQuery } from '@tanstack/react-query';
import { WarehouseApi } from '@/lib/warehouse-api';
import { queryKeys } from '@/config/query-keys';

export function useFacilities() {
  return useQuery({
    queryKey: queryKeys.facilities.list(),
    queryFn: () => WarehouseApi.getFacilities(),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
  });
}
